import React from 'react'

import styled from 'styled-components'

import { Icon } from '_components/icon'
import { palette } from '_styles/variables'

const Container = styled.span`
  display: block;
  position: relative;
  box-sizing: border-box;
  width: 1.5rem;
  height: 1.5rem;
  min-width: 1.5rem;
  min-height: 1.5rem;
  border: 1px solid ${palette.neutral['grey-bbbdbf']};
  border-radius: 0.25rem;
  margin-right: 0.75rem;

  input:not(:checked) ~ && svg {
    opacity: 0;
  }

  input:checked ~ && {
    background-color: ${palette.ui.blue};
    border: none;
    padding: 0.12rem 0.12rem 0.18rem 0.18rem;
    color: ${palette.neutral.white};
  }

  > svg {
    vertical-align: unset;
    overflow: hidden;
  }
`

export const Checkmark: React.FC<
  React.ComponentPropsWithoutRef<'span'>
> = props => (
  <Container {...props}>
    <Icon size="1.2rem" icon="check" />
  </Container>
)
